import './style.scss';

import React, {useState} from "react";
import SortArrow from "../common/sortArrow";

const SortHeader = (props) => {
  const {
    label,
    defaultSortDirection,
    changeAction
  } = props;

  const [sortDirection, setSortDirection] = useState('');

  const clickSort = () => {
    const newSortDirection = (sortDirection === 'descending') ? 'ascending' : 'descending';
    setSortDirection(newSortDirection);
    changeAction(newSortDirection);
  }

  return (
    <div className='sort-header'>
      <div className='header-label'><button className='sort-header-button' onClick={clickSort}>{label}</button></div>
      <div className='sort-direction'>
        <SortArrow defaultSortDirection={defaultSortDirection} sortDirection={sortDirection} changeAction={clickSort}/>
      </div>
    </div>
  );
}

export default SortHeader;